import { css } from 'aphrodite';
import * as React from 'react';
import type { IUser } from '../../../extViewmodels';
import { getDisplayName } from '../../../models/NameUtils';
import { UserCombobox, UserComboboxAvatarItem, UserComboboxStatus } from '../../../web/components/UserCombobox';
import { ComboboxContent, ComboboxInput, ComboboxList } from '../../../web/components-v2/Combobox';
import { inboxStyles as s } from './styles/inboxStyles';

interface TicketFilterCsmRowProps {
	csmId?: string;
	csmName?: string;
	onChange: (csm?: { id: string; name: string }) => void;
}

/**
 * The "CSM" row of the Search criteria popover. Deliberately the same employee autocomplete as the
 * account details "assign CSM" field (`user/autocomplete` under the admin's own session, never
 * impersonated), so the two surfaces always offer the same people. The selected display name is
 * what the search endpoint matches against each account's customer-success name.
 */
export const TicketFilterCsmRow: React.FC<TicketFilterCsmRowProps> = ({ csmId, csmName, onChange }) => (
	<div className={css(s.filterRow)}>
		<span className={css(s.filterCsmLabel)}>CSM</span>
		{/* Remount on selection change so the combobox re-resolves its input text from the id. */}
		<UserCombobox
			id={csmId}
			key={csmId ?? 'none'}
			onValueChange={(user: IUser | null) => onChange(user ? { id: user.id, name: getDisplayName(user) } : undefined)}
		>
			<ComboboxInput
				aria-label='Filter by CSM'
				placeholder={csmName ?? 'Anyone'}
				showClear={!!csmId}
				styles={[s.filterCsmInput]}
			/>
			<ComboboxContent>
				<UserComboboxStatus />
				<ComboboxList>{(user: IUser) => <UserComboboxAvatarItem key={user.id} user={user} />}</ComboboxList>
			</ComboboxContent>
		</UserCombobox>
	</div>
);
